import { getDiffFromNow } from '../../../../../shared/utils/date-time';
import {
  DANGER_TIME_IN_MIN,
  URGENCY_TIME_IN_MIN,
  WARNING_TIME_IN_MIN,
  turboHelper,
} from '../../domain';

import OrdersUtils from 'utils/OrdersUtils';
import type {
  ITurboCase,
  ITurboCaseParams,
  orderCreationTimeStatus,
} from '../../domain';

export function orderTurboCase(params: ITurboCaseParams): ITurboCase {
  const { order } = params;
  const _specialOrder = order?.special_order ?? [];
  const _createdAt = order?.created_at || '';
  const isTurboqueue = turboHelper.isTurboqueue(_specialOrder);
  const isRTInStore = OrdersUtils.isRTInStore(order);

  // TODO: fn name is not following the PascalCase convention
  const _getcreatedAtStatus = (): orderCreationTimeStatus => {
    if (!isTurboqueue || !Boolean(_createdAt)) {
      return '';
    }
    const { min } = getDiffFromNow(_createdAt);
    if (min >= URGENCY_TIME_IN_MIN) {
      return 'urgency';
    }
    if (min >= DANGER_TIME_IN_MIN) {
      return 'danger';
    }
    if (min >= WARNING_TIME_IN_MIN) {
      return 'warning';
    }
    return '';
  };

  return {
    isTurboqueue,
    createdAtStatus: _getcreatedAtStatus(),
    isRTInStore,
  };
}
